
import Vue from 'vue';
import { ValidationObserver, extend } from 'vee-validate';
import {
  required, email, regex, confirmed,
} from 'vee-validate/dist/rules';
import { mapActions } from 'vuex';
import BackgroundImage from '@/components/BackgroundImage/index.vue';
import Button from '@/components/Button/index.vue';
import Card from '@/components/Card/index.vue';
import Heading from '@/components/Heading/index.vue';
import Input from '@/components/InputWithValidation/index.vue';
import LogoAgrotools from '@/components/Logos/Agrotools/index.vue';
import LogoPrincipal from '@/components/Logos/Principal/index.vue';
import Modal from '@/components/ModalLogin/index.vue';
import IconWhatsApp from '@/components/Icons/WhatsApp/index.vue';
import LogoPrograma from '@/components/Logos/Programa/index.vue';

import {
  encrypt, getUserGroup, isBayer, isValidLanguage,
} from '@/utils';
import resetPasswordService from '@/services/user/reset-password';
import {
  LinkForgotPassword,
  LinkSignOn,
  LinkSignOnLink,
  LinkSignOnLinkWhatsApp,
  LoginErrorMessage,
  TextNotRegistered,
  WrapperButton,
  WrapperInput,
  WrapperMain,
  WrapperSignOn,
} from './styles';

extend('required', { ...required });
extend('email', { ...email });

export default Vue.extend({
  components: {
    BackgroundImage,
    Button,
    Card,
    Heading,
    Input,
    LinkForgotPassword,
    LinkSignOn,
    LinkSignOnLink,
    LinkSignOnLinkWhatsApp,
    LoginErrorMessage,
    LogoAgrotools,
    LogoPrincipal,
    LogoPrograma,
    TextNotRegistered,
    ValidationObserver,
    WrapperButton,
    WrapperInput,
    WrapperMain,
    Modal,
    WrapperSignOn,
    IconWhatsApp,
  },
  data() {
    return {
      email: '',
      expired: false,
      isBayer: false,
      isBayerArg: false,
      loading: false,
      loginError: false,
      isOpenModal: true,
      isOpenModalCentral: false,
      password: {
        current: '',
        new: '',
        confirm: '',
      },
      passwordError: false,
      sendMessageLink: '',
      idCrypt: '',
      errorMessage: '',
    };
  },
  methods: {
    ...mapActions({ login: 'login' }),

    async onSubmit() {
      this.loading = true;

      const response = await this.login({
        stEmail: this.email,
        stPassword: encrypt(this.password.current),
        // fkApplication: process.env.VUE_APP_ID,
        stDns: this.isBayerArg
          ? process.env.VUE_APP_APPLICATION_DNS_AR : process.env.VUE_APP_APPLICATION_DNS,
      });

      this.loading = false;

      if (response.hasErrors) {
        this.errorMessage = response.message;
        this.loginError = true;
        return;
      }

      this.$router.replace(`${getUserGroup()}`);
    },
    close() {
      this.isOpenModal = false;
      this.isOpenModalCentral = false;
    },
    async onSubmitPassword() {
      this.loading = true;

      const response = await resetPasswordService({
        newPassword: encrypt(this.password.new),
        idCrypt: this.idCrypt,
        stDns: this.isBayerArg
          ? process.env.VUE_APP_APPLICATION_DNS_AR : process.env.VUE_APP_APPLICATION_DNS,
      });

      this.loading = false;
      if (response.status !== 200) {
        this.passwordError = response.data.message;
        return;
      }

      this.password.current = this.password.new;

      this.expired = false;
      this.loginError = false;

      this.onSubmit();
    },
    goToWatsapp() {
      window.open('https://wa.me/5512961861258');
    },
    goToStartRegister() {
      this.$router.replace('/comecar-agora');
    },
    goToStartPrem() {
      window.open('https://reconectamt-test.agrotools.com.br/');
    },
    goToStartVoucher() {
      window.open('https://atmarket.agrotools.com.br/product/voucher/voucher-reconecta');
    },
    goToStartCentral() {
      this.isOpenModalCentral = true;
    },

    goToRecoverPassword() {
      this.$router.replace('/esqueci-minha-senha');
    },
  },
  created() {
    const { lang } = this.$route.query;
    if (isValidLanguage(lang as string)) {
      sessionStorage.setItem('language', lang as string);
      this.$i18n.locale = lang as string;
    }
  },
  async mounted() {
    this.isBayer = isBayer();
    this.isBayerArg = isBayer() && this.$i18n.locale === 'es-AR';

    extend('required', {
      ...required,
      message: this.$t('required_field', { field: this.$t('password') }) as string,
    });

    extend('regex', {
      ...regex,
      message: this.$t('password_rules') as string,
    });

    extend('confirmed', {
      ...confirmed,
      message: this.$t('password_confirm_error') as string,
    });
  },
});
